import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ASSETS_FEATURE_GROUP } from './group';
import { ASSETS_COLORS_MODULE } from './colors';
import { ASSETS_DESCRIPTION_MODULE } from './description';
import { ASSETS_IMAGES_MODULE } from './images';
import { ASSETS_TYPOGRAPHY_MODULE } from './typography';

/**
 * Basic read access to the assets section.
 * Used as the permission for the /assets tab and the GET /api/organization/assets endpoint.
 * Granular sub-section access is controlled by the dedicated sub-feature groups.
 */
export const ASSETS_FEATURES = {
  READ: {
    guid: 'a3c15f90-7e2d-4b8a-a614-9f0e83d20001',
    name: 'assets:read',
    description: 'View organization assets and their details',
    action: 'read',
    product: 'account',
    parentGuid: ASSETS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ASSETS_FEATURE_GROUP } from './group';
export { ASSETS_COLORS_FEATURES, ASSETS_COLORS_FEATURE_GROUP } from './colors';
export { ASSETS_DESCRIPTION_FEATURES, ASSETS_DESCRIPTION_FEATURE_GROUP } from './description';
export { ASSETS_IMAGES_FEATURES, ASSETS_IMAGES_FEATURE_GROUP } from './images';
export { ASSETS_TYPOGRAPHY_FEATURES, ASSETS_TYPOGRAPHY_FEATURE_GROUP } from './typography';

const ASSETS_SUB_MODULES: FeatureModule[] = [
  ASSETS_COLORS_MODULE,
  ASSETS_DESCRIPTION_MODULE,
  ASSETS_IMAGES_MODULE,
  ASSETS_TYPOGRAPHY_MODULE,
];

export const ASSETS_MODULE: FeatureModule = {
  product: 'account',
  groups: [ASSETS_FEATURE_GROUP, ...ASSETS_SUB_MODULES.flatMap((m) => m.groups)],
  features: [...featureList(ASSETS_FEATURES), ...ASSETS_SUB_MODULES.flatMap((m) => m.features)],
};
